/**
 * Side-page chrome: portals title into #page-header and back (+ actions) into #breadcrumbs-buttons.
 */
import { h } from 'preact'
import { createPortal } from 'preact/compat'
import { drive_index_path } from '../../routes'
import { createDriveI18n } from './side-utils.js'

export function DriveSideChrome({ titleKey, titleIcon = 'bi-cloud', actions = null, children }) {
  const i18n = createDriveI18n()
  const t = (key) => i18n.t(key)

  const headerEl = typeof document !== 'undefined' ? document.getElementById('page-header') : null
  const buttonsEl = typeof document !== 'undefined' ? document.getElementById('breadcrumbs-buttons') : null

  const title = (
    <>
      <i class={`bi ${titleIcon} me-2`} />
      {t(titleKey)}
    </>
  )

  const buttons = (
    <>
      <a href={drive_index_path()} class="btn btn-outline-secondary">
        <i class="bi bi-arrow-left" />
        <span class="d-none d-lg-inline ms-1">{t('drive.back_to_drive')}</span>
      </a>
      {actions}
    </>
  )

  return (
    <>
      {headerEl ? createPortal(title, headerEl) : null}
      {buttonsEl ? createPortal(buttons, buttonsEl) : null}
      {children}
    </>
  )
}
